import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  HostBinding,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

declare var PhotoSwipe;
declare var PhotoSwipeUI_Default;

@Component({
    selector: "file-preview",
    template: `
    @if (imageFile) {
      <img #imageElement [src]="imageFile" alt="imageFile" />
    }
    <ng-content></ng-content>
    `,
    styleUrls: ["./file-preview.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class FilePreviewComponent {
  @Input() set file(file) {
    if (file) {
      if (typeof file === "string" && file.startsWith("http")) {
        this.imageFile = file;
        this.imageFileNoSecurity = file;
        this.changeDetectorRef.detectChanges();
      } else if (file instanceof File) {
        this.readURL(file);
      } else {
        this.readBlob(file);
      }
      this.componentDisplay = "block";
    } else {
      this.componentDisplay = "none";
    }
  }
  @ViewChild("imageElement", { static: false }) imageElement: ElementRef;
  @HostBinding("style.display") componentDisplay = "none";
  imageFile;
  private imageFileNoSecurity;

  constructor(private sanitizer: DomSanitizer, private changeDetectorRef: ChangeDetectorRef) { }

  private readURL(input) {
    const reader = new FileReader();
    reader.readAsDataURL(input);

    reader.onload = (ev) => {
      this.imageFile = (ev?.target as any).result;
      this.imageFileNoSecurity = this.imageFile;
      this.changeDetectorRef.detectChanges();
    };
  }

  private readBlob(input) {
    const urlCreator = window.URL;
    const imageUrl = urlCreator.createObjectURL(input);
    this.imageFile = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
    this.imageFileNoSecurity = input;
    this.changeDetectorRef.detectChanges();
  }

  preview() {
    const pswpElement = document.querySelectorAll(".pswp")[0];

    const items = [
      {
        src: this.imageFileNoSecurity,
        w: this.imageElement.nativeElement.naturalWidth,
        h: this.imageElement.nativeElement.naturalHeight,
      },
    ];

    const options = {
      index: 0,
      showHideOpacity: true,
      captionEl: false,
      fullscreenEl: false,
      counterEl: false,
    };
    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  }
}
